import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Find.css';

function FindPassword() {
	const [step, setStep] = useState(1); // 1: 이메일 입력, 2: 인증코드 입력, 3: 새 비밀번호 입력
	const [email, setEmail] = useState('');
	const [code, setCode] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [newPassword2, setNewPassword2] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const [timeLeft, setTimeLeft] = useState(0);
	const navigate = useNavigate();

	// 타이머
	React.useEffect(() => {
		if (timeLeft > 0) {
			const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
			return () => clearTimeout(timer);
		}
	}, [timeLeft]);

	// 1단계: 이메일로 인증코드 발송
	const handleSendCode = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		try {
			await axios.post('http://127.0.0.1:8000/api/users/send-password-reset-code/', {
				email: email
			});

			setStep(2);
			setTimeLeft(300); // 5분
		} catch (error) {
			if (error.response?.data?.error) {
				setError(error.response.data.error);
			} else {
				setError('인증코드 발송에 실패했습니다. 다시 시도해주세요.');
			}
		} finally {
			setLoading(false);
		}
	};

	// 2단계: 인증코드 확인
	const handleVerifyCode = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		try {
			await axios.post('http://127.0.0.1:8000/api/users/verify-password-reset-code/', {
				email: email,
				code: code
			});

			setStep(3);
		} catch (error) {
			if (error.response?.data?.error) {
				setError(error.response.data.error);
			} else {
				setError('인증코드가 올바르지 않습니다.');
			}
		} finally {
			setLoading(false);
		}
	};

	// 3단계: 새 비밀번호 설정
	const handleResetPassword = async (e) => {
		e.preventDefault();
		setError('');

		if (newPassword !== newPassword2) {
			setError('비밀번호가 일치하지 않습니다.');
			return;
		}

		if (newPassword.length < 8) {
			setError('비밀번호는 8자 이상이어야 합니다.');
			return;
		}

		const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/;
		if (!passwordRegex.test(newPassword)) {
			setError('비밀번호는 영문과 숫자를 포함해야 합니다.');
			return;
		}

		setLoading(true);

		try {
			await axios.post('http://127.0.0.1:8000/api/users/reset-password/', {
				email: email,
				code: code,
				new_password: newPassword
			});

			alert('비밀번호가 변경되었습니다. 로그인해주세요.');
			navigate('/login');
		} catch (error) {
			if (error.response?.data?.error) {
				setError(error.response.data.error);
			} else {
				setError('비밀번호 변경에 실패했습니다. 다시 시도해주세요.');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="find-container">
			<div className="find-box">
				<h2>비밀번호 찾기</h2>

				{step === 1 && (
					<>
						<p className="find-description">가입 시 등록한 이메일 주소를 입력하세요.</p>

						{error && <div className="error-message">{error}</div>}

						<form onSubmit={handleSendCode}>
							<div className="form-group">
								<label>이메일</label>
								<input
									type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder="example@email.com"
									required
								/>
							</div>

							<button type="submit" className="btn-submit" disabled={loading}>
								{loading ? '발송 중...' : '인증코드 발송'}
							</button>
						</form>
					</>
				)}

				{step === 2 && (
					<>
						<p className="find-description">
							<strong>{email}</strong>로 발송된 인증코드를 입력하세요.
						</p>

						{error && <div className="error-message">{error}</div>}

						<form onSubmit={handleVerifyCode}>
							<div className="form-group">
								<label>
									인증코드
									{timeLeft > 0 && (
										<span className="timer">
											⏰ {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')} 남음
										</span>
									)}
								</label>
								<input
									type="text"
									value={code}
									onChange={(e) => setCode(e.target.value)}
									placeholder="6자리 코드 입력"
									maxLength="6"
									required
								/>
							</div>

							<button type="submit" className="btn-submit" disabled={loading}>
								{loading ? '확인 중...' : '인증코드 확인'}
							</button>

							<button
								type="button"
								className="btn-resend"
								onClick={() => {
									setStep(1);
									setCode('');
									setError('');
								}}
							>
								다시 발송
							</button>
						</form>
					</>
				)}

				{step === 3 && (
					<>
						<p className="find-description">새로운 비밀번호를 입력하세요.</p>

						{error && <div className="error-message">{error}</div>}

						<form onSubmit={handleResetPassword}>
							<div className="form-group">
								<label>새 비밀번호</label>
								<input
									type="password"
									value={newPassword}
									onChange={(e) => setNewPassword(e.target.value)}
									placeholder="8자 이상, 영문+숫자"
									required
								/>
							</div>

							<div className="form-group">
								<label>새 비밀번호 확인</label>
								<input
									type="password"
									value={newPassword2}
									onChange={(e) => setNewPassword2(e.target.value)}
									placeholder="비밀번호 재입력"
									required
								/>
							</div>

							<button type="submit" className="btn-submit" disabled={loading}>
								{loading ? '변경 중...' : '비밀번호 변경'}
							</button>
						</form>
					</>
				)}

				<div className="find-footer">
					<Link to="/find-username">아이디 찾기</Link>
					<span className="divider">|</span>
					<Link to="/login">로그인</Link>
					<span className="divider">|</span>
					<Link to="/register">회원가입</Link>
				</div>
			</div>
		</div>
	);
}

export default FindPassword;